<template>
  <div>
    <v-row style="margin-top: 1px;">
      <v-col cols="12" v-if="rol != 'AGENTPARTNER'">
        <cotizacionesHUb v-if="rol != 'AGENTCCSPONSORS' && globalConfig.showQuotesDashboard"></cotizacionesHUb>
        <!-- comparador -->
        <solicitudHUB></solicitudHUB>
      </v-col>
    </v-row>
    <DocsValidadosView v-if="screen === 1" @updateScreen="screen = $event"></DocsValidadosView>
  </div>
</template>

<script>
import cotizacionesHUb from "../../components/homeComponents/cotizacionesHUB.vue";
import solicitudHUB from "../../components/homeComponents/solicitudHUB.vue";
import DocsValidadosView from "../pages/docsProspectos/DocsValidadosView.vue";
import { mainAxios } from '@/mainAxios.js';
export default {
  components: { cotizacionesHUb, solicitudHUB, DocsValidadosView },
  data() {
    return {
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      globalConfig: JSON.parse(localStorage.getItem("globalConfig")) ?? {},
      screen: -1, // propiedad para controlar la pantalla que se muestra
    };
  },
  methods: {
      async checkHasSeenScreen() {
      try {
        const config = {
          headers: { Authorization: `Bearer ${localStorage.agenteAccessToken}` },
        };
        // Verifica si el usuario ha visto la pantalla de bienvenida
        const uuid = this.getAgentUuid();
        const agente = await this.fetchAgent(uuid, config);
        const vistaBienvenida = await this.fetchWelcomeScreenStatus(agente.id, config);

        this.screen = this.determineScreen(vistaBienvenida, agente.alianzaId);
      } catch (error) {
        console.error("Error en checkHasSeenScreen:", error.message || error);
      }
    },

    getAgentUuid() {
      // Obtiene el UUID del agente desde localStorage
      const uuid = localStorage.getItem("agenteUuid");
      if (!uuid) throw new Error("No se encontró el UUID del agente");
      return uuid;
    },

    async fetchAgent(uuid, config) {
      // Realiza una solicitud para obtener los datos del agente
      const { data: agente } = await mainAxios.get(`/v1/agente/${uuid}`, config);
      if (!agente?.id) throw new Error("ID de agente no encontrado");
      return agente;
    },

    async fetchWelcomeScreenStatus(agentId, config) {
      try {
      // Realiza una solicitud para obtener el estado de la pantalla de bienvenida
      const { data } = await mainAxios.get(`/v1/agente/vista_bienvenida/${agentId}`, config);
      return data.vista_bienvenida;
      } catch (error) {
      return false; // Retorna false automáticamente en caso de error
      }
    },

    determineScreen(vistaBienvenida, alianzaId) {
      // Determina qué pantalla mostrar según el estado de la pantalla de bienvenida y el rol del usuario
      if (!vistaBienvenida && this.rol === "AGENT" && this.globalConfig.showWelcomeAgentScreen && !alianzaId) {
        return 1; // Pantalla de documentos validados
      }
      return 0; // Pantalla de cotizaciones
    },
  },
  computed: {},
  mounted() {
    this.checkHasSeenScreen();
  },
};
</script>
